import React from "react";
import video from "./videos/storyboard-6.mp4";
import ArrowButton from "./ArrowButton";
import "./Capabilities3ConversationalAiScreen.scss";
import { useTranslation } from "react-i18next";
import { t } from "i18next";

function Capabilities3ConversationalAiScreen() {
  const { t, i18n } = useTranslation();
  return (
    <div className="fill-absolute">
      <div className="container full-height row mobile-nav-padding">
        <div className="full-height padding flex vertical-center">
          <h2 className="green-header">
            <div
              dangerouslySetInnerHTML={{
                __html: t("Capability3.title_html", {
                  interpolation: { escapeValue: false },
                }),
              }}
            />
          </h2>
          <p>{t("Capability3.section1")}</p>
          <p>{t("Capability3.section2")}</p>
        </div>
        <div className="full-height padding flex full-center">
          <video autoPlay muted loop>
            <source src={video} type="video/mp4" />
            {t("Capability3.video")}
          </video>
        </div>
      </div>
      <div className="buttons-container">
        <ArrowButton to="/capabilities-biometrics" side="left"></ArrowButton>
        <ArrowButton
          to="/capabilities-virtual-coworkers"
          side="right"
        ></ArrowButton>
      </div>
    </div>
  );
}

export default Capabilities3ConversationalAiScreen;
